import { extends as _extends, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useImageLoaded } from '@costar-ui/hooks';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import Slot from '../layout/slot/slot.esm.js';
import Initials from '../initials/initials.esm.js';
import { ArtworkBuilding } from '../artwork/artwork-building.esm.js';

var _excluded = ["title", "alt", "src", "initials", "placeholder", "size", "loading", "imageRef", "className", "testId", "suppressOnImageError"];
var PrivateLogo = /*#__PURE__*/forwardRef(function Logo(props, ref) {
  var theme = useComponentTheme('Logo');
  var _props = _objectSpread2({}, props),
    title = _props.title,
    alt = _props.alt,
    src = _props.src,
    initials = _props.initials,
    _props$placeholder = _props.placeholder,
    placeholder = _props$placeholder === void 0 ? false : _props$placeholder,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    loading = _props.loading,
    imageRef = _props.imageRef,
    className = _props.className,
    testId = _props.testId,
    suppressOnImageError = _props.suppressOnImageError,
    rest = _objectWithoutProperties(_props, _excluded);
  var wrapperClasses = useMemo(function () {
    return theme.base({
      className: className,
      size: size
    });
  }, [theme, size, className]);
  var imageMeta = useImageLoaded({
    src: src
  });
  if (suppressOnImageError && imageMeta.state === 'error') {
    return null;
  }
  var placeholderHeight = placeholder ? 'h-40' : '';
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    testId: testId,
    ref: ref,
    className: "csg-tw-logo-wrapper relative bg-neutral-subtlest  ".concat(wrapperClasses, " ").concat(placeholderHeight),
    justify: "center",
    alignItems: "center"
  }, rest), src ? /*#__PURE__*/React__default.createElement("img", {
    className:
    //'csg-tw-logo absolute left-0 top-0 z-[1] h-auto min-h-full w-full max-w-full bg-base object-contain',
    'csg-tw-logo h-auto min-h-full w-full max-w-full bg-base object-contain',
    src: src,
    alt: alt,
    title: title,
    ref: imageRef,
    loading: loading
  }) : null, initials !== null && initials !== void 0 && initials.firstInitial ? /*#__PURE__*/React__default.createElement(Initials, {
    firstInitial: initials === null || initials === void 0 ? void 0 : initials.firstInitial
  }) : null, placeholder ? /*#__PURE__*/React__default.createElement(ArtworkBuilding, null) : null);
});
var Logo = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PrivateLogo, _extends({
    ref: ref
  }, props));
});
Logo.displayName = 'Logo';
var Logo$1 = Logo;

export { PrivateLogo, Logo$1 as default };
//# sourceMappingURL=logo.esm.js.map
